import React, {useContext} from "react";
import "./ProjectDomains.scss";
import {projectDomainsSection} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function ProjectDomains() {
  const {isDark} = useContext(StyleContext);
  if (!projectDomainsSection.display) {
    return null;
  }
  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main" id="project-domains">
        <div className="project-domains-main-div">
          <div className="project-domains-header">
            <h1
              className={
                isDark
                  ? "dark-mode heading project-domains-heading"
                  : "heading project-domains-heading"
              }
            >
              {projectDomainsSection.title}
            </h1>
            <p
              className={
                isDark
                  ? "dark-mode subTitle project-domains-subtitle"
                  : "subTitle project-domains-subtitle"
              }
            >
              {projectDomainsSection.subtitle}
            </p>
          </div>
          <div className="project-domains-cards-div">
            {projectDomainsSection.domains.map((domain, i) => {
              return (
                <div
                  key={i}
                  className={
                    isDark
                      ? "dark-mode project-domain-card project-domain-card-dark"
                      : "project-domain-card project-domain-card-light"
                  }
                >
                  <div className="project-domain-icon">{domain.icon}</div>
                  <h5
                    className={
                      isDark
                        ? "dark-mode project-domain-title"
                        : "project-domain-title"
                    }
                  >
                    {domain.name}
                  </h5>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </Fade>
  );
}
